class QuickView extends HTMLElement {
    constructor() {
        super();
        this.modal = document.querySelector('[data-quick-modal]');
        this.wrapper = this.modal.querySelector('[data-quick-container]');
        this.close = this.modal.querySelector('[data-quick-additional-close]');
        this.handle= this.dataset.quickOpen;
        this.addEventListener('click', this.onButtonClick.bind(this));
        this.modal.addEventListener('click', this.onModalClick.bind(this));
        this.close.addEventListener('click', this.onButtonCloseClick.bind(this));
    }
    onButtonClick(event){
        
        event.preventDefault();
       

        fetch(`/products/${this.handle}?section_id=js-quick-view`)
        .then(response => response.text()).then(data => { 
          $(this.wrapper).html(data);
        }).then(()=>{
            this.modal.classList.add('opened');
            document.body.classList.add('rebuy-modal-visible');
        }).then(()=>{
            this.runScripts();
        })
    }

    onModalClick(event){
        if (!event.target.closest('.modal__dialog')) {
            this.modal.classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');
                        
        }
    }

    onButtonCloseClick(){
        this.modal.classList.remove('opened');
        document.body.classList.remove('rebuy-modal-visible');
    }

    runScripts(){
        // init gallerys
        const galleryThumbs = new Swiper('.quick-view-gallery-thumbs', { 
            direction: 'vertical',
            slidesPerView: 4,
            spaceBetween: 10,
            loop: false,
                navigation: {
                nextEl: '.quick-view__swiper-button-next',
                prevEl: '.quick-view__swiper-button-prev',
            },
        });

        const swiper = new Swiper("#mySwiperQuickWiew", {
            slidesPerView: "auto",
            thumbs: {
                swiper: galleryThumbs,
            },
        });
        galleryThumbs.controller.control = galleryThumbs;
       

        // init swatch
        const radios = document.querySelectorAll('.quick-view .swatch-element input[type="radio"]');
        
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                const optionIndex = this.closest('.swatch').getAttribute('data-option-index');
                const optionValue = this.value;
                const form = this.closest('form');
                const singleOptionSelectors = form.querySelectorAll('.single-option-selector');
        
                if (singleOptionSelectors[optionIndex]) {
                    singleOptionSelectors[optionIndex].value = optionValue;
                    singleOptionSelectors[optionIndex].dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });


        // init variants
        const $container = $('.quick-view_inner');
        const options = {
            $container: $container,
            enableHistoryState: false,
            singleOptionSelector: '.single-option-selector-js-quick-view',
            originalSelectorId: '#ProductSelect-js-quick-view',
            product: JSON.parse(document.getElementById("ProductJson-js-quick-view").innerHTML),
        };
  
        const variants = new slate.Variants(options); 

        $container.on("variantChange",updateVariant);

        function updateVariant(data) {
            const variant = data.variant;

            // update images
            if(variant.available){
                if(variant.featured_image){
                    const thumbnail = document.querySelector(`.quick-view-gallery-thumbs [data-thumbnail-id="${variant.featured_image.id}"]`);
                    if(thumbnail){
                        swiper.slideTo(thumbnail.dataset.slide);
                    }
                }
            }

            // update button state
            const addToCartButton = $container.find('[data-add-to-cart]');
            const addToCartButtonText = $container.find('[data-add-to-cart-text]');
            if(variant.available){ 
                addToCartButton.attr('disabled',false);
                addToCartButtonText.html('Add to cart ' + Shopify.formatMoney(variant.price));
            } else {
                addToCartButton.attr('disabled',true);
                addToCartButtonText.html('Sold Out');
            }

            // update price
            const price = $container.find('[data-regular-price]');
            price.html(Shopify.formatMoney(parseInt(variant.price)));
        }


        // init add to cart function 
        const productForm = $container.find('.product-form-js-quick-view');
        productForm.on("submit", function (evt) {
            evt.preventDefault();

            document.querySelector('[data-quick-modal]').classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');

            theme.Product.prototype._addItemToCart(productForm[0]);
        });

        // init Rebuy vidget
        if($container.hasClass('quick-view_bundle') && window.Rebuy){
            Rebuy.init();
        }

        document.addEventListener('rebuy:cart.change', (event) => { 
            this.modal.classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');
        });
          
    }
}
customElements.define('quick-view', QuickView);
